import React, {Component} from 'react'
import ReactTable from 'react-table'
import 'react-table/react-table.css'

import {withSubscription} from '../HOC/subscription'

const renderCellByType = (columns) => {
    return columns.map(column => {
        if(column.type){
            switch(column.type){
                case 'colour':
                    column['Cell'] = (row) => (<div
                        style={{
                            width: '100%',
                            height: '100%',
                            backgroundColor: `${row.value}`,
                            borderRadius: '2px'
                        }}
                    ></div>)
                    break
            }

        }
        return column
    })
}

export default (schema, dataStructure, uniqueKey, columns) => {

    const formattedColumns = renderCellByType(columns)

    class AUTable extends Component{

        constructor(props){
            super(props)
        }

        render(){
            const {data} = this.props
            return (
                <div>
                    <ReactTable
                        style={{display: 'flex', flex: 1, fontSize: '14px'}}
                        className="-striped -highlight"
                        data={data[schema]}
                        columns={formattedColumns}
                        getTrProps={(state, rowInfo) => {
                            return {
                                onClick: (e) => {
                                    this.props.onRowClick(rowInfo)
                                }
                            }
                        }}
                    />
                </div>
            )
        }
    }

    return withSubscription(AUTable, schema, dataStructure, uniqueKey)
}
